import React from 'react';
import { Checkbox } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export default function VisibilizerEditor(props) {
  return /*#__PURE__*/_jsx(Checkbox, {
    label: "Is Visible?",
    ...props
  });
}